import { NgModule } from '@angular/core';
import { RouterModule, NoPreloading } from '@angular/router';

import AppRoutes from './app.routes';

@NgModule({
    imports: [
        RouterModule.forRoot(AppRoutes, {
            useHash: false,
            preloadingStrategy: NoPreloading,
        }),
    ],
    exports: [RouterModule],
    declarations: [],
})
export class AppRoutingModule {}
